"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
var of_1 = require("rxjs/observable/of");
var zip_1 = require("rxjs/observable/zip");
var operators_1 = require("rxjs/operators");
var interpreter_utils_1 = require("./interpreter-utils");
var meta_1 = require("./model/meta");
var module_loading_service_1 = require("./module-loading.service");
var logger = interpreter_utils_1.createLogger('module-registry');
var ModuleRegistryService = /** @class */ (function () {
    function ModuleRegistryService(loader) {
        this.loader = loader;
    }
    ModuleRegistryService_1 = ModuleRegistryService;
    ModuleRegistryService.extractControlMetadata = function (type, moduleKey) {
        var controlMetadata = Reflect['getMetadata']('dynamic:module', type);
        if (controlMetadata) {
            var component = type['__annotations__'][0];
            return new meta_1.MetaControl(component.selector, controlMetadata.name, controlMetadata.template, controlMetadata.cellCount, controlMetadata.isHeader, controlMetadata.iconInfo, controlMetadata.settings
                ? {
                    main: controlMetadata.settings.main
                        ? ModuleRegistryService_1.extractControlMetadata(controlMetadata.settings.main)
                        : undefined,
                    central: controlMetadata.settings.central
                        ? ModuleRegistryService_1.extractControlMetadata(controlMetadata.settings.central)
                        : undefined,
                    bottom: controlMetadata.settings.bottom
                        ? ModuleRegistryService_1.extractControlMetadata(controlMetadata.settings.bottom)
                        : undefined,
                }
                : undefined, controlMetadata.groups, controlMetadata.defaultActions, controlMetadata.isFieldBound, moduleKey, controlMetadata.isSubwayMap, controlMetadata.nameKey, controlMetadata.height);
        }
        else {
            return undefined;
        }
    };
    ModuleRegistryService.extractModuleMetadata = function (moduleAndSummary) {
        var result = [];
        if (moduleAndSummary.type !== undefined &&
            moduleAndSummary.type['__annotations__'] !== undefined) {
            for (var _i = 0, _a = moduleAndSummary.type['__annotations__'][0]
                .exports; _i < _a.length; _i++) {
                var type = _a[_i];
                var metaControl = ModuleRegistryService_1.extractControlMetadata(type, moduleAndSummary.moduleKey);
                if (metaControl) {
                    result.push({
                        control: metaControl,
                        controlType: type,
                        moduleType: moduleAndSummary.type,
                        summary: moduleAndSummary.summary,
                    });
                }
            }
        }
        else if (moduleAndSummary.type === undefined) {
            logger.error('one of module types was undefined');
        }
        else if (moduleAndSummary.type['__annotations__'] === undefined) {
            logger.error('no annotation was found for %o type', moduleAndSummary.type);
        }
        return result;
    };
    ModuleRegistryService.prototype.findControl = function (key) {
        logger.info('loading control by key %s', key);
        return this.allControlsMapped().pipe(operators_1.map(function (controlMap) { return controlMap.get(key); }), operators_1.tap(function (_) { return logger.info('successfully loaded control by key %s', key); }));
    };
    ModuleRegistryService.prototype.findModuleAndControlType = function (key, fixedModuleKeys) {
        logger.info('loading module by key %s', key);
        return this.controlMetaAndTypeArray(fixedModuleKeys).pipe(operators_1.map(function (typeAndControls) {
            return typeAndControls.find(function (value) { return value.control.selector === key; });
        }), operators_1.tap(function (_) { return logger.info('successfully loaded module by key %s', key); }));
    };
    ModuleRegistryService.prototype.availableControls = function (fixedModuleKeys) {
        return this.allControlsMapped(fixedModuleKeys).pipe(operators_1.map(function (controlMap) { return controlMap.valueSeq(); }));
    };
    ModuleRegistryService.prototype.allControlsMapped = function (fixedModuleKeys) {
        return this.controlMetaAndTypeArray(fixedModuleKeys).pipe(operators_1.map(function (metasAndType) {
            return immutable_1.Map().withMutations(function (mutable) {
                metasAndType.forEach(function (meta) {
                    return mutable.set(meta.control.selector, meta.control);
                });
            });
        }), operators_1.publishReplay(1), operators_1.refCount());
    };
    ModuleRegistryService.prototype.controlMetaAndTypeArray = function (fixedModuleKeys) {
        var _this = this;
        return this.getProperModuleKeys(fixedModuleKeys).pipe(operators_1.switchMap(function (modules) {
            return zip_1.zip.apply(void 0, modules
                .map(function (module) {
                return zip_1.zip.apply(void 0, [_this.getModuleKeyAndType(module)].concat(_this.loader.loadSummariesIfAvailable(module), [function (moduleKeyAndType) {
                        var values = [];
                        for (var _i = 1; _i < arguments.length; _i++) {
                            values[_i - 1] = arguments[_i];
                        }
                        // const moduleKeyAndType = values[0] as ModuleKeyAndType;
                        var summary = values;
                        return {
                            type: moduleKeyAndType.type,
                            moduleKey: moduleKeyAndType.moduleKey,
                            summary: summary,
                        };
                    }]));
            })
                .toArray());
        }), operators_1.map(function (data) {
            return data
                .filter(function (module) { return !!module; })
                .map(function (moduleType) {
                return ModuleRegistryService_1.extractModuleMetadata(moduleType);
            });
        }), operators_1.map(function (matrix) { return [].concat.apply([], matrix); }), operators_1.publishReplay(1), operators_1.refCount());
    };
    ModuleRegistryService.prototype.getProperModuleKeys = function (fixedModuleKeys) {
        if (!lodash_1.isNil(fixedModuleKeys) && fixedModuleKeys.length > 0) {
            return of_1.of(immutable_1.List(fixedModuleKeys));
        }
        return this.loader.availableModules();
    };
    ModuleRegistryService.prototype.getModuleKeyAndType = function (moduleKey) {
        return this.loader.loadModule(moduleKey).pipe(operators_1.map(function (moduleType) {
            return {
                moduleKey: moduleKey,
                type: moduleType,
            };
        }));
    };
    ModuleRegistryService = ModuleRegistryService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [module_loading_service_1.ModuleLoadingService])
    ], ModuleRegistryService);
    return ModuleRegistryService;
    var ModuleRegistryService_1;
}());
exports.ModuleRegistryService = ModuleRegistryService;
//# sourceMappingURL=module-registry.service.js.map